module.exports = "/images/Bulgaria.png?d1dd2588c3427830552739077cf8786c";